import React from 'react'
import { Modal } from 'antd'

interface PreviewRemoteDocumentProps {
  open: boolean
  documentName: string
  pdfUrl: string
  onClose: () => void
  pageNumber?: number
}

const PreviewRemoteDocument: React.FC<PreviewRemoteDocumentProps> = ({
  open,
  documentName,
  pdfUrl,
  onClose,
  pageNumber
}) => {
  const [blobUrl, setBlobUrl] = React.useState<string | null>(null)

  React.useEffect(() => {
    let url: string | null = null
    if (open && pdfUrl) {
      fetch(pdfUrl)
        .then((response) => response.blob())
        .then((blob) => {
          url = URL.createObjectURL(blob)
          setBlobUrl(url)
        })
    }
    return () => {
      if (url) {
        URL.revokeObjectURL(url)
      }
      setBlobUrl(null)
    }
  }, [open, pdfUrl])

  return (
    <Modal
      open={open}
      title={documentName}
      onCancel={onClose}
      footer={null}
      width="100%"
      style={{ padding: 24 }}
      bodyStyle={{ padding: 0, height: 800 }}
      destroyOnClose
      centered
    >
      {blobUrl ? (
        <object
          data={`${blobUrl}#page=${pageNumber || 1}`}
          type="application/pdf"
          width="100%"
          height="800"
          style={{ border: 0 }}
        />
      ) : (
        <div style={{ textAlign: 'center', padding: 48 }}>Loading document...</div>
      )}
    </Modal>
  )
}

export default PreviewRemoteDocument
